import { render, staticRenderFns } from "./DisposalOrdersTable.vue?vue&type=template&id=0339a1e8&scoped=true"
import script from "./DisposalOrdersTable.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0339a1e8",
  null
  
)

export default component.exports